











































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ChatBoard from "@/components/chat/ChatBoard.vue";
import { mapGetters, mapActions } from "vuex";

@Component({
	components: {
		"chat-board": ChatBoard
	},
	computed: {
		...mapGetters("chat", [
			"admins",
			"contributers",
			"members",
			"chats",
			"loading"
		]),
		...mapGetters("project", ["projects"])
	},
	methods: {
		...mapActions("chat", ["getProjectByChatName", "setRoomId"])
	}
})
export default class Chat extends Vue {
	@Prop({ type: String, required: true })
	id!: string;
	chatgruplist = false;
	searchGroups = "";
	loadingchat!: any;
	projects!: any;

	admins!: [any];
	contributers!: [any];
	members!: [any];
	chats!: [any];
	loading!: boolean;
	getProjectByChatName!: Function;
	setRoomId!: Function;

	created() {
		this.loadingchat = this.$vs.loading({
			type: "circles",
			color: "#FF6",
			background: "#000",
			opacity: 0.8,
			scale: 1.3,
			text: "Loading chats..."
		});

		this.getProjectByChatName(this.id);
		this.setRoomId(this.id);
	}

	toggleChatList() {
		this.chatgruplist = !this.chatgruplist;
	}

	set filteredProjects(val: any) {
		this.projects = val;
	}
	get filteredProjects() {
		const jp = this.projects.filter((project: any) => {
			return project.title.toLowerCase().match(this.searchGroups);
		});
		return jp;
	}

	openChat(id: string) {
		this.getProjectByChatName(id);
		this.setRoomId(id);
		this.$router.push({ name: "Chat", params: { id } });
	}

	@Watch("loading")
	onLoadingChage(newVal: boolean, prevVal: boolean) {
		// FIXME: remove on prod
		if (!(newVal && !this.$socket.connected)) {
			setTimeout(() => this.loadingchat.close(), 1000);
		}
	}
}
